module.exports = __webpack_public_path__ + "img/plane-a320v2.e2de22a7.svg";